import React, {useRef, useContext} from 'react';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {Card, ListGroup} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import { updateFileExtra } from '../../../../services/MadricService';
import { MadricContext } from '../../../../Context/MadricContext';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function PDF(props) {

  const {projectInfo, setProjectInfo} = useContext(MadricContext);
  
  const extra = useRef({
    extra1: props.file.extra1,
    extra2: props.file.extra2,
    extra3: props.file.extra3
  });

 /**
 * Permet de modifier les extras
 * @param {*} event event
 */
 async function handleChangeExtra(event) {
  extra.current = {
    ...extra.current,
    [event.target.name]: event.target.checked,
  };


  const updatedFile = projectInfo.map((p) => {
    if (p.id === props.file.id && p.type === 'file') {
      return {
        ...p,
        extra1: extra.current.extra1,
        extra2: extra.current.extra2,
        extra3: extra.current.extra3

      };
    }
    return p;
  });
  setProjectInfo(updatedFile);
  await updateFileExtra(props.file.id, extra.current);
}



  const navigate = useNavigate();
  const {id} = useParams();

  const file = props.file;
  const returnTo = 'historique';

  return (
    <div className="checkin-container" style={{minWidth: '90%'}}>
      <Card className="checkin-card" style={{minWidth: '90%'}}>
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>PDF</span> {props.formatDate(props.file.date)}
          <button className="checkin-pagination-button float-end" onClick={() => navigate('/UpdateFile', {state: {file, id, returnTo}})}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <LazyLoadImage
              style={{width: '120px', height: '120px'}}
              src="/images/pdf.png"
              alt="error"
              className="chantierheure-photo"
              placeholderSrc="/images/pdf.png"
              effect="blur"
            />
          </ListGroup.Item>


          <ListGroup.Item className="checkin-list-item">
          Employé: {props.file.user_name}
          </ListGroup.Item>

          <ListGroup.Item className="checkin-list-item">
          Permission: {props.file.permission ? 'OUI' : 'NON'}
          </ListGroup.Item>

          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.file.extra1}
              label="Extra possible"
              onChange={handleChangeExtra}
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
            <React.Fragment>
              <MDBCheckbox
                name="extra2"
                id="inlineCheckbox222"
                defaultChecked={props.file.extra2}
                label="Extra valider"
                onChange={handleChangeExtra}
                inline
              />
              <MDBCheckbox
                name="extra3"
                id="inlineCheckbox333"
                defaultChecked={props.file.extra3}
                label="Extra confirmer"
                onChange={handleChangeExtra}
                inline
              />
            </React.Fragment>
          ) : (
            ' '
          )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
          Note: {props.file.note}
          </ListGroup.Item>

          <ListGroup.Item className="checkin-list-item " style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Button onClick={() => {
              navigate('/UpdateFile', {state: {file, id}});
            }} style={{marginTop: '0px', marginRight: '10px', backgroundColor: 'red', color: 'white'}}>

        Selectionner
            </Button>
          </ListGroup.Item>
        </ListGroup>
      </Card>

    </div>
  );
}

export default PDF;
